import { SET_DRAG_ACTION, TOGGLE_EDITOR_REFRESH_NEEDED } from '@/store/mutation-types'

export default {
  namespaced: true,
  state: {
    dragAction: null,
    editorRefreshNeeded: false,
  },

  mutations: {
    [SET_DRAG_ACTION](state, dragAction) {
      state.dragAction = dragAction
    },
    [TOGGLE_EDITOR_REFRESH_NEEDED](state) {
      state.editorRefreshNeeded = !state.editorRefreshNeeded
    },
  },
  actions: {
    add({ commit }, dragAction) {
      commit(SET_DRAG_ACTION, dragAction)
    },
    toggleEditorRefreshNeeded({ commit }) {
      commit(TOGGLE_EDITOR_REFRESH_NEEDED)
    },
  },
}
